import {
  buildCustomerServiceUrl,
  UmbracoABTestModel,
  pushVirtualPageView,
  UserNavigationLinks,
  NavigationLink,
  UmbracoLink,
} from "@bn-monorepo/js-packages";

export interface HeaderData {
  homeLink: NavigationLink;
  bottomNavigationLinks: NavigationLink[];
  userNavigationLinks?: UserNavigationLinks;
  settingsLinks?: NavigationLink[];
  topNavigationLinks: NavigationLink[];
  strings: {
    account: string;
    jumpToNavigation: string;
    notification: string;
    bnLogoAltTextLoggedIn: string;
    darkModePrimaryText: string;
    darkModeSecondaryText: string;
  };
}

export interface MenuLink {
  name: string;
  url: string;
  type: "External" | "Internal" | "Content";
}

interface Level2 {
  link: UmbracoLink;
  iconInlineSvg: string;
  hidden: {
    mobile: boolean;
    desktop: boolean;
  };
}
interface Level1 extends Level2 {
  list: Level2[];
}
export interface MegaMenu {
  list: Level1[];
  headerButtons: Level2[];
}

export interface HeaderCms {
  documentType: string;
  menuLinks: MenuLink[];
  menuOpenLabel: string;
  logoAltText: string;
  loginLabel: string;
  loginLink: string;
  myPageLabel: string;
  logoutLabel: string;
  myPageLink: string;
  logoutLink: string;
  homeLink: string;
  megaMenu: MegaMenu;
}

export const getPageContent = (path: string, search: string, navigate, settings, isSpaNavigation: boolean) => {
  const extraParams = new URLSearchParams(search);
  const previewId = extraParams.get("previewId");
  const { resolveUrl, apiBaseUrl } = settings;

  const uri = `${apiBaseUrl}/pageContent/getcontent?v=2&path=${path}${previewId ? `&previewId=${previewId}` : ""}`;

  return fetch(uri)
    .then((response) => {
      if (!response.ok) {
        if (response.status === 404) {
          //This is ok, response should contain 404 page
          return response.json();
        }

        throw Error(response.statusText);
      }
      return response.json();
    })
    .then((cmsContent) => {
      const contentPath = resolveUrl(cmsContent.canonicalPath);

      if (cmsContent.name !== "404" && !previewId && cmsContent && contentPath !== path) {
        navigate(contentPath, { replace: true });
      }

      switch (cmsContent.documentType) {
        case "customerServiceCategories":
        case "customerServiceCategory":
        case "customerServiceSecondLevelCategory": {
          const urlToCustomerService = buildCustomerServiceUrl(
            cmsContent.breadcrumbs[1],
            cmsContent.breadcrumbs[3],
            cmsContent.breadcrumbs[4],
          );
          navigate(urlToCustomerService);

          break;
        }
        default:
      }
      const abTest = cmsContent.abTest as UmbracoABTestModel;
      pushVirtualPageView(cmsContent.meta.title, isSpaNavigation ? "spa_navigation" : "first_load", {
        currentVariant: cmsContent.path,
        abTest,
      });
      return Promise.resolve(cmsContent);
    });
};

export const getHeader = (path: string, settings) => {
  const { apiBaseUrl } = settings;
  return fetch(`${apiBaseUrl}/header?v=2&path=${path}`).then<HeaderCms>((response) => response.json());
};

export const getFooter = (path: string, settings) => {
  const { apiBaseUrl } = settings;
  return fetch(`${apiBaseUrl}/footer?v=2&path=${path}`).then((response) => response.json());
};

export const getHeaderData = (path) => {
  return fetch(`/login/status?path=${encodeURIComponent(path)}`, {
    credentials: "same-origin",
  }).then<HeaderData>((response) => response.json());
};

export const getMessages = () => {
  return fetch("/api/mypage/messages", {
    credentials: "same-origin",
  }).then((response) => response.json());
};
